import { idAndNameArrayPropType } from './id-and-name-array-prop-type'

/**
 * Proptype that represents an array of available sections (id + name)
 * @typedef {Array.<itemSourcesPropType>}  availableSectionsPropType
 */
export const availableSectionsPropType = idAndNameArrayPropType
